<template>
    <div style="height: 100%;position: relative">
        <div
                v-if="isDisabled"
                style=" height: 100%; width: 100%;  position: absolute;  z-index: 1000; background-color: #ababab73;">
        </div>
        <vue-list
                :items="entities"
                :buttons="buttons"
                :groupBy="groupBy"
                :isCheckedList="isCheckedList"
                :selectedItem.sync="selectedItem"
                @checkedItemsChanged="onCheckedItemsChanged"
        >
            <template slot-scope="{item}">
                <slot :item="item"></slot>
            </template>
            <template slot="header">
                <slot name="header"></slot>
            </template>
        </vue-list>
        <v-btn v-if="operations.includes('create')"
               color="blue darken-2"
               dark
               absolute
               bottom
               :style="{left: '25px', bottom: '25px'}"
               left
               fab
               @click="onAddButtonClick"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import Vue from 'vue'

    import VueList from '@/components/vue-list/vue-list'

    import {isString} from 'lodash/core'

    export default {
        props: {
            entities: {
                type: Array,
                default: () => []
            },
            operations: {
                type: Array,
                default: () => ['create', 'update', 'delete']
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            selectedEntity: {
                type: String,
                default: null
            },
            groupBy: {
                type: Function,
                default: null
            },
            isCheckedList: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                selectedItem: this.selectedEntity
            }
        },
        computed: {
            buttons() {
                const buttons = [];

                this.operations.forEach(operation => {
                    const type = isString(operation) ? operation : operation.type;

                    switch (type) {
                        case 'update':
                            buttons.push({
                                icon: 'el-icon-edit-outline',
                                condition: operation.condition,
                                title: 'Изменить',
                                onClick: id => this.onEditButtonClick(id)
                            });
                            break;
                        case 'delete':
                            buttons.push({
                                icon: 'el-icon-close',
                                condition: operation.condition,
                                title: 'Удалить',
                                onClick: id => this.onRemoveButtonClick(id)
                            });
                            break;
                        case 'copy':
                            buttons.push({
                                icon: 'mdi-content-copy',
                                condition: operation.condition,
                                title: 'Создать копию',
                                onClick: id => this.onCopyButtonClick(id)
                            });
                            break;
                        case 'custom':
                            buttons.push({
                                icon: operation.icon,
                                condition: operation.condition,
                                title: operation.title,
                                onClick: operation.onClick
                            });
                            break;
                    }
                });

                return buttons;
            }
        },
        methods: {
            onAddButtonClick() {
                if (this.selectedItem) {
                    this.selectedItem = null;
                    setTimeout(() => {
                        this.$emit('addButtonClick');
                    }, 250);
                } else
                    this.$emit('addButtonClick');
            },
            onEditButtonClick(entityId) {
                this.selectedItem = null;
                this.$emit('editButtonClick', entityId);
            },
            onRemoveButtonClick(entityId) {
                this.selectedItem = null;
                this.$emit('removeButtonClick', entityId);
            },
            onCopyButtonClick(entityId) {
                this.selectedItem = null;
                this.$emit('copyButtonClick', entityId);
            },
            updateSelectedEntity(val) {
                if (val !== this.selectedEntity)
                    this.$emit('update:selectedEntity', val);
            },
            onCheckedItemsChanged(val) {
                this.$emit('checkedEntitiesChanged', val);
            }
        },

        components: {
            VueList
        },

        watch: {
            selectedItem(newVal) {
                this.updateSelectedEntity(newVal);
            },
            selectedEntity(newVal) {
                this.selectedItem = newVal;
            }
        }

    }
</script>

<style scoped>

</style>
